import {
  REQUEST_NOTICE_LIST_FOR_MAIN_PAGE,
  REQUEST_NOTICE_LIST,
  REQUEST_NOTICE_DTL
} from './mutation-types';

export default {
  [REQUEST_NOTICE_LIST_FOR_MAIN_PAGE] (state, receivedData) {
    state.mainPageNotices = receivedData
  },
  [REQUEST_NOTICE_LIST] (state, receivedData) {
    state.notices = receivedData.content;
    state.noticeCount = receivedData.totalElements;
  },
  [REQUEST_NOTICE_DTL] (state, receivedData) {
    state.notice = receivedData
  }
}